import RequestService from './request-service';

/**
 * Class for getting quick links from SB Admin
 */
export default class QuickLinksRequest extends RequestService {
  constructor() {
    super();
    this.method = 'get';
    this.endpoint = this.$config.endpoints.quickLinks;
    this.getParams = {
      Culture: APP_SETTINGS.player.language,
      Platform: getQuickLinksPlatform(),
    };
  }
}

function getQuickLinksPlatform() {
  if (process.env.VUE_APP_IS_MOBILE) {
    return 2;
  }
  if (process.env.VUE_APP_IS_AGENT) {
    return 4;
  }
  if (APP_SETTINGS && APP_SETTINGS.settings && APP_SETTINGS.settings.isSSBT) {
    return 3;
  }
  return 1;
}